module.exports = __webpack_public_path__ + "img/yellow-babina.412b197e.png";